// import "core-js/es6/map";
// import "core-js/es6/set";
// import "core-js/fn/array/find";
// import "core-js/fn/array/includes";
// import "core-js/fn/number/is-nan";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";

import App from "./App";
import { BASE_NAME } from "./utils/Urls";

import "./index.css";

import registerServiceWorker from "./registerServiceWorker";

import { initialState } from "./store/initialState";
import rootReducer from "./store/rootReducer";
import { saveState } from "./store/persistState";
import { throttle, registerAutoCartClear } from "./utils/CommonFunctions";
import { devToolsEnhancer } from "redux-devtools-extension";
export let store;
if (process.env.NODE_ENV !== "production") {
  store = createStore(rootReducer, initialState, devToolsEnhancer());
} else {
  store = createStore(rootReducer, initialState);
}

const app = (
  <Provider store={store}>
    <BrowserRouter basename={BASE_NAME}>
      <App />
    </BrowserRouter>
  </Provider>
);

store.subscribe(
  throttle(() => {
    const {
      cartItems,
      filters,
      currentFoodCourtDetails,
      currentRestaurantDetails,
      immutableSubMenu,
      multiRestaurantDetails,
      immutableMultiSubMenu,
      restaurantsList,
      firebaseStaticData,
      cafePass,
      slotDisplay,
      preorderData,
      sessionsData
    } = store.getState();
    let paymentDetails, restaurantDetails, userDetails, foodNa, acceptsodexo;

    if (currentRestaurantDetails) {
      paymentDetails = currentRestaurantDetails.paymentoptions;
      restaurantDetails = currentRestaurantDetails.restextras;
      userDetails = currentRestaurantDetails.loginextras;
      foodNa = currentRestaurantDetails.FoodNa;
      acceptsodexo = currentRestaurantDetails.acceptsodexo;
    }

    let stateToBeStored = {
      cartItems,
      filters,
      paymentDetails,
      currentFoodCourtDetails,
      restaurantDetails,
      userDetails,
      FoodNa: foodNa,
      immutableSubMenu,
      acceptsodexo,
      multiRestaurantDetails,
      immutableMultiSubMenu,
      restaurantsList,
      cafePass,
      slotDisplay,
      preorderData,
      sessionsData,
      firebaseStaticData
    };

    let localCartItem = localStorage.getItem("state");
    if (localCartItem === null) {
      saveState(stateToBeStored);
      return;
    }
    localCartItem = JSON.parse(localCartItem).cartItems;
    let cartItemNames = Object.keys(localCartItem);
    if (cartItemNames.length !== 0) {
      let currentFoodCourtId = localStorage.getItem("currentFoodCourt");
      if (currentFoodCourtId) {
        currentFoodCourtId = JSON.parse(currentFoodCourtId).value;
      }
      let skipCheck = localStorage.getItem("skipCheck");
      if (skipCheck) {
        localStorage.removeItem("skipCheck");
      }
      let newFoodCourtId = cartItemNames[0].split(":")[0];
      if (currentFoodCourtId === newFoodCourtId || skipCheck === "true") {
        saveState(stateToBeStored);
      }
    } else {
      saveState(stateToBeStored);
    }
  }, 2000)
);

ReactDOM.render(app, document.getElementById("root"));
registerServiceWorker();
registerAutoCartClear();



// WEBPACK FOOTER //
// ./src/index.js